// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#app{font-family:PingFang SC;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;text-align:center;overflow:hidden}#nav{padding:1.5625vw}#nav a{font-weight:700;color:#2c3e50}#nav a.router-link-exact-active{color:#42b983}", ""]);
// Exports
module.exports = exports;
